/**
* GoogleAnalyticsEvent.js
*
* @author Reinier Feijen for Ranj
**/
export default class GoogleAnalyticsEvent {
    constructor(type) {
        this.type = type;
    };
}

GoogleAnalyticsEvent.INIT = "GoogleAnalyticsEvent.INIT";
GoogleAnalyticsEvent.INITIALIZED = "GoogleAnalyticsEvent.INITIALIZED";
GoogleAnalyticsEvent.USER = "GoogleAnalyticsEvent.USER";
GoogleAnalyticsEvent.DIMENSION = "GoogleAnalyticsEvent.DIMENSION";

GoogleAnalyticsEvent.SESSION_START = "GoogleAnalyticsEvent.SESSION_START";
GoogleAnalyticsEvent.SESSION_END = "GoogleAnalyticsEvent.SESSION_END";
GoogleAnalyticsEvent.EVENT = "GoogleAnalyticsEvent.EVENT";
GoogleAnalyticsEvent.ERROR = "GoogleAnalyticsEvent.ERROR";

GoogleAnalyticsEvent.FILL = "GoogleAnalyticsEvent.FILL";